import firebase from 'firebase/app'
export default firebase.initializeApp({
  apiKey: 'AIzaSyBOCGi5O2AWj9ZGrlB5aX3b0p4pzweHdeI',
  authDomain: 'waitress-6bc72.firebaseapp.com',
  databaseURL: 'https://waitress-6bc72.firebaseio.com',
  projectId: 'waitress-6bc72',
  storageBucket: 'waitress-6bc72.appspot.com',
  messagingSenderId: '907648036225',
  appId: '1:907648036225:web:70a665b921ecd84ffa8c80'
})
